class HeaderDropdown extends HTMLElement {
  constructor () {
    super()
    this.mobileHeaderLinks = this.querySelectorAll(`.hd-MobileNav_HeaderLink`)
    this.mobileLinkTitles = this.querySelectorAll(`.hd-MobileNav_Link-title`)
    this.mobileLinkReturns = this.querySelectorAll(`.hd-MobileNav_HeaderSelected`)
    this.mobileColumns = this.querySelectorAll(`.hd-MobileNav_Column`)
    this.mobileLinks = this.querySelectorAll(`.hd-MobileNav_Link`)
    this.mobileHeaderSelected = this.querySelector(`.hd-MobileNav_HeaderSelected`)
    this.mobileHeaderSelectedTitle = this.querySelector(`.hd-MobileNav_HeaderSelectedTitle`)

    this.setupEventListeners()
  }

  setupEventListeners () {
    this.mobileHeaderLinks.forEach(el => {
      el.addEventListener('click', this.handleLevelOneClick.bind(this))
    })

    this.mobileLinkTitles.forEach(el => {
      el.addEventListener('click', this.handleLevelTwoClick.bind(this))
    })

    this.mobileLinkReturns.forEach(el => {
      el.addEventListener('click', this.handleLevelTwoReturnClick.bind(this))
    })
  }

  handleLevelOneClick (event) {
    this.mobileHeaderLinks.forEach(link => {
      link.classList.remove('hd-MobileNav_HeaderLink-open')
    })

    event.target.classList.add('hd-MobileNav_HeaderLink-open')

    this.mobileColumns.forEach(column => {
      if (column.dataset?.id === event.target.dataset?.id) {
        column.classList.add('hd-MobileNav_Column-open')
      } else {
        column.classList.remove('hd-MobileNav_Column-open')
      }
    })
  }

  handleLevelTwoClick (event) {
    if (event.target.tagName === 'A') return

    const mobileLinkTitleId = event.target.closest('button').dataset.id

    this.mobileLinkTitles.forEach(link => {
      link.setAttribute('aria-hidden', 'true')
    })

    this.mobileLinks.forEach(link => {
      if (link.dataset.id === mobileLinkTitleId && link !== event.target) {
        link.removeAttribute('aria-hidden')
      }
    })

    this.mobileHeaderSelected.removeAttribute('aria-hidden')
    this.mobileHeaderSelectedTitle.textContent = event.target.closest('button').textContent
  }

  handleLevelTwoReturnClick (event) {
    this.mobileLinks.forEach(link => {
      link.setAttribute('aria-hidden', 'true')
    })

    this.mobileLinkTitles.forEach(link => {
      link.removeAttribute('aria-hidden')
    })

    this.mobileHeaderSelected.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}

const mobileMenuToggle = document.querySelector('.hd-Drawer_Container')
const htmlEl = document.querySelector('html')

if (mobileMenuToggle) {
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.attributeName === 'open') {
        if (mobileMenuToggle.hasAttribute('open')) {
          htmlEl.classList.add('mobile-menu-open')
        } else {
          htmlEl.classList.remove('mobile-menu-open')
        }
      }
    }
  }
  const observer = new MutationObserver(callback)
  observer.observe(mobileMenuToggle, { attributes: true })
}
